/* ========================================
   PRODUCT PAGE — JavaScript
   Handles: gallery, variant selection, tier teaser,
   founder card, accordions, sticky ATC, scroll animations
   ======================================== */

(function() {
  'use strict';

  /* --- Gallery --- */
  function initGallery() {
    var gallery = document.querySelector('.ig-gallery');
    if (!gallery) return;

    var mainWrap = gallery.querySelector('.ig-gallery-main');
    var mainImage = gallery.querySelector('.ig-gallery-main img');
    // Only the configurator hero carries this <video>; the other heroes skip it.
    var mainVideo = gallery.querySelector('.ig-gallery-video');
    var thumbs = gallery.querySelectorAll('.ig-gallery-thumb');
    var prevBtn = gallery.querySelector('.ig-gallery-nav-arrow.prev');
    var nextBtn = gallery.querySelector('.ig-gallery-nav-arrow.next');
    var currentIndex = 0;
    var totalImages = thumbs.length;

    // Hide nav arrows when there's nothing to navigate to (was generating
    // dead clicks on single-image products per Clarity 2026-04-24)
    if (totalImages <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    function setImage(index) {
      currentIndex = index;
      var thumb = thumbs[index];
      var videoSrc = thumb && mainVideo && thumb.getAttribute('data-video-src');
      if (videoSrc) {
        // Video thumb: play the muted loop over the image. Properties as well as
        // attributes — mobile browsers refuse to autoplay on the attributes alone.
        if (mainVideo.getAttribute('src') !== videoSrc) mainVideo.src = videoSrc;
        var vImg = thumb.querySelector('img');
        if (vImg) mainVideo.setAttribute('aria-label', vImg.alt);
        mainVideo.muted = true;
        mainVideo.playsInline = true;
        mainWrap.classList.add('is-video');
        var playing = mainVideo.play();
        if (playing && playing.catch) playing.catch(function() {});
      } else if (thumb) {
        if (mainVideo) mainVideo.pause();
        if (mainWrap) mainWrap.classList.remove('is-video');
        var img = thumb.querySelector('img');
        if (img && mainImage) {
          mainImage.src = img.getAttribute('data-full') || img.src;
          mainImage.srcset = '';
          mainImage.alt = img.alt;
        }
      }
      thumbs.forEach(function(t, i) {
        t.classList.toggle('active', i === index);
      });
      // Mobile strip scrolls horizontally: keep the active thumb in view.
      if (thumb && thumb.scrollIntoView) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { setImage(i); });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        setImage((currentIndex - 1 + totalImages) % totalImages);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        setImage((currentIndex + 1) % totalImages);
      });
    }

    // Keyboard navigation
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') setImage((currentIndex - 1 + totalImages) % totalImages);
      if (e.key === 'ArrowRight') setImage((currentIndex + 1) % totalImages);
    });
  }

  /* --- Variant Selection --- */
  function initVariantSelectors() {
    var heroSection = document.querySelector('[data-ig-product-hero]');
    if (!heroSection) return;

    var productData = null;
    try {
      var dataEl = heroSection.querySelector('[data-product-json]');
      if (dataEl) productData = JSON.parse(dataEl.textContent);
    } catch(e) {}

    // Tier selector
    var tierBtns = heroSection.querySelectorAll('[data-tier-btn]');
    var tierTeaser = heroSection.querySelector('.ig-tier-teaser');
    var founderCard = heroSection.querySelector('.ig-founder-card');
    var priceMain = heroSection.querySelector('.ig-price-main');
    var priceTier = heroSection.querySelector('.ig-price-tier');
    var tierSelectedValue = heroSection.querySelector('[data-tier-selected]');
    var specSheetLink = heroSection.querySelector('.ig-spec-sheet-link');

    /* Phase-0 instrumentation: how many PDP visitors reach the spec sheet at
       all. Without it there is no denominator for the /pages/customize funnel
       and no baseline for a pre-purchase configurator to beat. */
    if (specSheetLink) {
      specSheetLink.addEventListener('click', function() {
        if (typeof gtag !== 'function') return;
        var activeTier = heroSection.querySelector('[data-tier-btn].active');
        gtag('event', 'spec_sheet_link_click', {
          product_handle: heroSection.getAttribute('data-product-handle') || '',
          spec_tier: activeTier ? (activeTier.getAttribute('data-tier') || '') : ''
        });
      });
    }

    tierBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        tierBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var price = btn.getAttribute('data-price');
        var tier = btn.getAttribute('data-tier');
        var teaserText = btn.getAttribute('data-teaser');

        if (priceMain) priceMain.textContent = price;
        var priceAfter = heroSection.querySelector('[data-laborday-after]');
        if (priceAfter && btn.getAttribute('data-price-after')) priceAfter.textContent = btn.getAttribute('data-price-after');
        if (priceTier) priceTier.textContent = tier;
        if (tierSelectedValue) tierSelectedValue.textContent = tier;
        if (tierTeaser && teaserText) tierTeaser.textContent = teaserText;
        // Update the Add to Cart button text (secondary button)
        var addCartBtn = heroSection.querySelector('.ig-btn-buy-now');
        if (addCartBtn) addCartBtn.textContent = 'Add to Cart \u2014 ' + price;
        if (founderCard) founderCard.classList.toggle('visible', tier === 'Bespoke');

        // Update spec sheet link
        if (specSheetLink) {
          var handle = heroSection.getAttribute('data-product-handle') || '';
          specSheetLink.href = '/pages/customize?product=' + handle + '&tier=' + tier.toLowerCase();
        }

        // Update sticky ATC price
        var stickyPrice = document.querySelector('.sticky-atc__price, .ig-sticky-atc-price');
        if (stickyPrice) stickyPrice.textContent = price;

        // Update Shopify variant selection
        updateShopifyVariant(heroSection, productData);
      });
    });

    // Face material swatches
    var swatchBtns = heroSection.querySelectorAll('[data-swatch-btn]');
    swatchBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        swatchBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var material = btn.getAttribute('data-value');
        var label = heroSection.querySelector('[data-face-selected]');
        if (label) label.textContent = material;
        updateShopifyVariant(heroSection, productData);
      });
    });

    // Generic variant buttons (Hand, Type)
    heroSection.querySelectorAll('[data-variant-group]').forEach(function(group) {
      var btns = group.querySelectorAll('.ig-variant-btn');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          btns.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          var selectedLabel = group.querySelector('.ig-selected-value');
          if (selectedLabel) selectedLabel.textContent = btn.textContent.trim();
          updateShopifyVariant(heroSection, productData);
        });
      });
    });

    /* Apply availability on load. A tier that does not span every putter type
       (Stock, Regular only) must grey out the unreachable ones before the first
       click, and a deep link like ?variant=<stock id> has to land consistent. */
    updateShopifyVariant(heroSection, productData);

    // Quantity buttons
    var qtyValue = heroSection.querySelector('.ig-qty-value');
    var qtyBtns = heroSection.querySelectorAll('.ig-qty-btn');
    if (qtyValue && qtyBtns.length === 2) {
      qtyBtns[0].addEventListener('click', function() {
        var val = parseInt(qtyValue.textContent) || 1;
        if (val > 1) qtyValue.textContent = val - 1;
      });
      qtyBtns[1].addEventListener('click', function() {
        var val = parseInt(qtyValue.textContent) || 1;
        qtyValue.textContent = val + 1;
      });
    }
  }

  /* --- Update Shopify Variant ID ---
     ⚠️ Not every tier spans every putter type. Stock (added 2026-09-17) exists
     for Regular only, so Stock + Counterbalanced resolves to NOTHING. Until
     then every tier covered all four types and a match was guaranteed, so the
     original code simply did nothing when `find` came back undefined — leaving
     the hidden input on the PREVIOUS variant. The page then showed "STOCK —
     $549" while the cart still held Premium/Counterbalanced at $999: the buyer
     is shown one price and charged another.

     Two defences, because either alone can be defeated:
       1. Tier LEADS (see optionOrder in spec-config.js). Picking a tier snaps
          the other options to a combination that exists, rather than dead-ending.
       2. Options in the following groups that cannot be reached with the current
          tier are disabled outright, so the bad pair cannot be selected at all.
     If both somehow fail, the buy buttons are disabled rather than charging for
     a variant the buyer did not choose. */
  var TIER_OPTION = 'customization level';

  function variantMatching(productData, opts) {
    return productData.variants.find(function(v) {
      return productData.options.every(function(optName, i) {
        var want = opts[optName];
        return !want || v.options[i] === want;
      });
    });
  }

  function readSelection(heroSection) {
    var selected = {};
    heroSection.querySelectorAll('[data-option-name]').forEach(function(group) {
      var optionName = group.getAttribute('data-option-name');
      var activeBtn = group.querySelector('.ig-variant-btn.active, .ig-swatch-btn.active, [data-tier-btn].active');
      if (activeBtn) {
        selected[optionName] = activeBtn.getAttribute('data-value') || activeBtn.textContent.trim();
      }
    });
    return selected;
  }

  function activateValue(group, value) {
    var btns = group.querySelectorAll('.ig-variant-btn, .ig-swatch-btn');
    Array.prototype.forEach.call(btns, function(b) {
      var v = b.getAttribute('data-value') || b.textContent.trim();
      b.classList.toggle('active', v === value);
    });
    var label = group.querySelector('.ig-selected-value');
    if (label) label.textContent = value;
  }

  function refreshAvailability(heroSection, productData, selected) {
    heroSection.querySelectorAll('[data-option-name]').forEach(function(group) {
      var name = group.getAttribute('data-option-name');
      // The tier always stays clickable — it leads, and picking it snaps the rest.
      if (String(name).toLowerCase() === TIER_OPTION) return;
      var btns = group.querySelectorAll('.ig-variant-btn');
      Array.prototype.forEach.call(btns, function(btn) {
        var val = btn.getAttribute('data-value') || btn.textContent.trim();
        var probe = {};
        Object.keys(selected).forEach(function(k) { if (k !== name) probe[k] = selected[k]; });
        probe[name] = val;
        var reachable = !!variantMatching(productData, probe);
        btn.classList.toggle('ig-variant-btn--unavailable', !reachable);
        btn.disabled = !reachable;
        btn.setAttribute('aria-disabled', reachable ? 'false' : 'true');
      });
    });
  }

  function updateShopifyVariant(heroSection, productData) {
    if (!productData || !productData.variants) return;

    var selectedOptions = readSelection(heroSection);
    var matchedVariant = variantMatching(productData, selectedOptions);

    // No such combination — hold the tier and snap everything else to a real variant.
    if (!matchedVariant) {
      var tierName = Object.keys(selectedOptions).find(function(n) {
        return String(n).toLowerCase() === TIER_OPTION;
      });
      if (tierName) {
        var onlyTier = {};
        onlyTier[tierName] = selectedOptions[tierName];
        var fallback = variantMatching(productData, onlyTier);
        if (fallback) {
          heroSection.querySelectorAll('[data-option-name]').forEach(function(group) {
            var name = group.getAttribute('data-option-name');
            var i = productData.options.indexOf(name);
            if (i === -1 || String(name).toLowerCase() === TIER_OPTION) return;
            activateValue(group, fallback.options[i]);
          });
          matchedVariant = fallback;
          selectedOptions = readSelection(heroSection);
        }
      }
    }

    refreshAvailability(heroSection, productData, selectedOptions);

    var buyBtns = heroSection.querySelectorAll('.ig-btn-add-cart, .ig-btn-buy-now');
    Array.prototype.forEach.call(buyBtns, function(b) { b.disabled = !matchedVariant; });
    if (!matchedVariant) return;   // never leave the input on a stale variant

    var variantInput = heroSection.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = matchedVariant.id;

    var url = new URL(window.location);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url);
  }

  /* --- Accordions --- */
  function initAccordions() {
    document.querySelectorAll('.ig-accordion-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.parentElement;
        var content = item.querySelector('.ig-accordion-content');
        var isOpen = item.classList.contains('open');

        // Close all in this group
        var group = item.closest('.ig-accordion-group');
        if (group) {
          group.querySelectorAll('.ig-accordion-item').forEach(function(ai) {
            ai.classList.remove('open');
            ai.querySelector('.ig-accordion-content').style.maxHeight = '0';
          });
        }

        if (!isOpen) {
          item.classList.add('open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  /* --- Scroll Animations --- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ig-fade-up').forEach(function(el) {
        el.classList.add('visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.ig-fade-up').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* --- Purchase Buttons --- */
  function initAddToCart() {
    var heroSection = document.querySelector('[data-ig-product-hero]');
    if (!heroSection) return;

    // .ig-btn-add-cart = "Buy It Now" (gold, primary) → direct checkout
    var buyNowBtn = heroSection.querySelector('.ig-btn-add-cart');
    // .ig-btn-buy-now = "Add to Cart" (outline, secondary) → AJAX add to cart
    var addCartBtn = heroSection.querySelector('.ig-btn-buy-now');

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantInput = heroSection.querySelector('input[name="id"]');
        if (!variantInput) return;
        var qtyEl = heroSection.querySelector('.ig-qty-value');
        var qty = parseInt(qtyEl ? qtyEl.textContent : 1);
        window.location.href = '/cart/' + variantInput.value + ':' + qty + '?checkout';
      });
    }

    if (addCartBtn) {
      addCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantInput = heroSection.querySelector('input[name="id"]');
        var qtyEl = heroSection.querySelector('.ig-qty-value');
        if (!variantInput) return;

        var formData = {
          items: [{
            id: parseInt(variantInput.value),
            quantity: parseInt(qtyEl ? qtyEl.textContent : 1)
          }]
        };

        addCartBtn.disabled = true;
        var origText = addCartBtn.textContent;
        addCartBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          addCartBtn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // Go straight to the cart. The old behaviour added by AJAX and only
          // flipped the button label for two seconds, so the buyer saw nothing
          // happen — the header bubble updates too late and too small to read
          // as feedback. cart_type is already "page", so this matches it.
          window.location.href = window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        })
        .catch(function() {
          addCartBtn.textContent = 'Error - Try Again';
          addCartBtn.disabled = false;
        });
      });
    }
  }

  /* --- Initialize --- */
  document.addEventListener('DOMContentLoaded', function() {
    initGallery();
    initVariantSelectors();
    initAccordions();
    initScrollAnimations();
    initAddToCart();
  });
})();
